import React, { useState, useEffect } from "react";

const FileComponent: React.FC<{ fileName: string }> = ({ fileName }) => {
  const [fileUrl, setFileUrl] = useState<string | null>(null);

  useEffect(() => {
    const fetchFile = async () => {
      try {
        setFileUrl(fileName);
      } catch (error) {
        console.error("Error fetching file URL:", error);
      }
    };

    fetchFile();
  }, [fileName]);

  return fileUrl ? (
    <div>
 <img src={fileUrl} alt={fileName} className="dropzoneimage img-fluid" />
 sasa
    </div>
   
  ) : (
    <p>Loading...</p>
  );
};

export default FileComponent;
